// Module
var code = "<svg viewBox=\"0 0 5 8\" width=\"5\" height=\"8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.065 0L.006 4l4.059 3.999.929-.902L1.85 4 4.994.902z\" fill-rule=\"evenodd\"/></svg> ";
// Exports
module.exports = code;